import type { AxisKey, UniKey } from "./types.js";

export interface AxisDef {
  key: AxisKey;
  /** [negative pole, positive pole] */
  labels: [string, string];
  color: string;
}
export interface UniDef {
  key: UniKey;
  label: string;
  color: string;
}

export const AXES: AxisDef[] = [
  { key: "terrain", labels: ["Nature", "Urban"], color: "#3FA37C" },
  { key: "era", labels: ["Ancient", "Modern"], color: "#8A8FA8" },
  { key: "fame", labels: ["Hidden", "Iconic"], color: "#7A8CFF" },
  { key: "energy", labels: ["Serene", "Electric"], color: "#B07AFF" },
  { key: "lens", labels: ["Texture", "Spectacle"], color: "#5BC8C4" },
];
export const UNI: UniDef[] = [
  { key: "cul", label: "Food", color: "#E4572E" },
  { key: "adv", label: "Adventure", color: "#FF6B9D" },
  { key: "cra", label: "Immersion", color: "#8A8FA8" },
  { key: "nig", label: "Nightlife", color: "#B07AFF" },
  { key: "sho", label: "Shopping", color: "#F5C542" },
];

/** Cards shown per session before the deck cuts off. */
export const MAX_SWIPES = 26;
/** Seconds on the clock for a swipe session. */
export const SWIPE_SECONDS = 75;
